/**
 * Storage keys for image generation
 */

import type { StorageKeys } from '../types'

// Storage keys
export const STORAGE_KEYS: StorageKeys = {
  CONVERSATION_ID: 'image_generation_conversation_id',
  GENERATION_HISTORY: 'image_generation_history',
}

/**
 * Clear image generation storage
 */
export function clearImageGenerationStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.CONVERSATION_ID)
    localStorage.removeItem(STORAGE_KEYS.GENERATION_HISTORY)
  }
  catch (error) {
    console.warn('Failed to clear image generation storage:', error)
  }
}

/**
 * Get conversation ID from storage
 */
export function getStoredConversationId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEYS.CONVERSATION_ID)
  }
  catch {
    return null
  }
}

/**
 * Set conversation ID to storage
 */
export function setStoredConversationId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEYS.CONVERSATION_ID, id)
  }
  catch (error) {
    console.warn('Failed to save conversation ID:', error)
  }
}

/**
 * Get generation history from storage
 */
export function getStoredGenerationHistory<T>(): T[] {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.GENERATION_HISTORY)
    if (saved) {
      const parsed = JSON.parse(saved)
      if (Array.isArray(parsed))
        return parsed
    }
  }
  catch (error) {
    console.warn('Failed to load generation history:', error)
  }
  return []
}

/**
 * Set generation history to storage
 */
export function setStoredGenerationHistory<T>(history: T[]): void {
  try {
    if (history.length > 0)
      localStorage.setItem(STORAGE_KEYS.GENERATION_HISTORY, JSON.stringify(history))
  }
  catch (error) {
    console.warn('Failed to save generation history:', error)
  }
}
